import { GridOptions } from "@ag-grid-community/core";
import { formatMoneyWithoutCurrencySymbol } from "shared/utils/MoneyUtils";

export const MaybernTableDataTypeDefinitions: GridOptions["dataTypeDefinitions"] =
  {
    money: {
      extendsDataType: "text",
      baseDataType: "text",
      columnTypes: ["money"],
      appendColumnTypes: true,
      valueFormatter: (params) =>
        params.value ? formatMoneyWithoutCurrencySymbol(params.value) : "-",
    },
  };
